import * as React from 'react';
export var ContextSelectorContext = React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onSelect: function onSelect(event, value) {
    return undefined;
  }
});